import { HttpErrorResponse } from '@angular/common/http';

export class SetContractTypeAction {
  static readonly type = '[Contract] Set contract type';
  constructor(public type: string) {}
}

export class ContractResetAction {
  static readonly type = '[Contract] reset contract state';
}

export class DownloadContractAction {
  static readonly type = '[Contract] Download contract';
  constructor(public contractId: string) {}
}

export class DownloadContractSuccessAction {
  static readonly type = '[Contract] Download contract success';
  constructor(public fileDownloadLink: string) {}
}

export class DownloadContractFailedAction {
  static readonly type = '[Contract] Download contract failed';
  constructor(
    public error: HttpErrorResponse,
    public contractId: string
  ) {}
}
